import { NotFoundError } from './not-found-error';

export class MarketInvalidError extends NotFoundError {}
